<h1 class="page-title mb-5">كيف يمكننا أن نساعد</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            الهيئة العامة للاستثمار والمناطق الحرة هي هيئة اقتصادية عامة لها
            شخصية اعتبارية عامة تنظم الاستثمار في الدولة وتشجعه وتدعمه وتديره
            وتروج له بما يحقق خطة التنمية الاقتصادية للدولة ، ولها أن تنشئ
            فروعاً لها. أو مكاتب داخل جمهورية مصر العربية أو في الخارج بقرار من
            مجلس الإدارة كجزء من بعثات التمثيل التجاري. ​​
          </p>
        </div>
        <ul class="links-nav-cont p-0 m-0" id="pills-tab" role="tablist">
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/CareEgyptianInvestorsComponent'"
              title="وحدة رعاية المستثمرين المصريين المقيمين بالخارج">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department1.png"
                  onerror="this.src='assets/images/placeholder.jpg'"
                  title="وحدة رعاية المستثمرين المصريين المقيمين بالخارج"
                  alt="وحدة رعاية المستثمرين المصريين المقيمين بالخارج" />
              </div>
              <span>وحدة رعاية المستثمرين المصريين المقيمين بالخارج</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/EconomicperformanceHelpComponent'" title="بيانات إحصائية">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department2.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="بيانات إحصائية" alt="بيانات إحصائية" />
              </div>
              <span>بيانات إحصائية</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/InvestorsCenterComponent'" title="مركز خدمات المستثمرين">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department1.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="مركز خدمات المستثمرين"
                  alt="مركز خدمات المستثمرين" />
              </div>
              <span>مركز خدمات المستثمرين</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/SocialResponsibilityComponent'"
              title="المسئولية المجتمعية للشركات">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department2.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="المسئولية المجتمعية للشركات"
                  alt="المسئولية المجتمعية للشركات" />
              </div>
              <span>المسئولية المجتمعية للشركات</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/InvestorsAgentsComponent'" title="مركز وكلاء المستثمرين بالهيئة">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department1.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="مركز وكلاء المستثمرين بالهيئة"
                  alt="مركز وكلاء المستثمرين بالهيئة" />
              </div>
              <span>مركز وكلاء المستثمرين بالهيئة</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/InvestorsDisputeComponent'" title="مركز تسوية منازعات المستثمرين">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department2.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="مركز تسوية منازعات المستثمرين"
                  alt="مركز تسوية منازعات المستثمرين" />
              </div>
              <span>مركز تسوية منازعات المستثمرين</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/EgyptianCitizenshipComponent'"
              title="وحدة منح الجنسية المصرية مقابل الاستثمار">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department1.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="وحدة منح الجنسية المصرية مقابل الاستثمار"
                  alt="وحدة منح الجنسية المصرية مقابل الاستثمار" />
              </div>
              <span>وحدة منح الجنسية المصرية مقابل الاستثمار</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/FrequentlyAskedQuestionsComponent'" title="الأسئلة الشائعة">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department2.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="الأسئلة الشائعة" alt="الأسئلة الشائعة" />
              </div>
              <span>الأسئلة الشائعة</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>